import { Box, FormGroup, FormLabel, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'
import NumberInput from './inputs/NumberInput';
import CurrencyInput from './inputs/CurrencyInput';

const formLabelStyle = {color: '#A1A1A1', fontWeight:'bold', fontSize:{xs: '1rem',}, display: 'flex', pb:'0.6rem' };


function DependencyRuleIf({item, index}) {
    return (
        <Box
            key={index}
            sx={{
                borderBottom: 1,
                borderColor: "#A1A1A1"
            }}
        >
            <Box
                sx={{
                    p: 1,
                    backgroundColor: "#A1A1A1"
                }}
            >
                {item.characteristicName}
            </Box>
            {item.values?.map((val, vindex) => (
                <Box key={vindex} sx={{ p: 1 }}>
                    {val}
                </Box>
            ))}
        </Box>
    )
}

function DependencyRuleThen({item, index, onChangeDependencyValue}) {
    return (
        <Box
            key={index}
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                p: 2
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    gap: 3
                }}
            >
                <Box>
                    <FormLabel>CARACTERÍSTICA</FormLabel>
                    <Typography>
                        {item.characteristicName}
                    </Typography>
                </Box>

                <Box>
                    <FormLabel>VALORES</FormLabel>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: 3,
                            p: 1
                        }}
                    >
                    {item.values.map((val, vindex) => (
                        <Box
                            key={vindex}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                width: "100%",
                                borderBottom: 1,
                                borderColor: "#A1A1A1",
                                gap: 2,
                                pb: 2
                            }}
                        >
                            <Typography>{val.valueName}</Typography>
                            
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-evenly",
                                        gap: 2
                                    }}
                                >
                                    {
                                        (
                                            item.characteristicCategory === "dimensions_only" || 
                                            item.characteristicCategory === "price_and_dimensions"
                                        ) && (
                                        <>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: { xs: "column", md: "row" },
                                                    justifyContent: "space-evenly",
                                                    gap: 2
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <FormLabel>Largo</FormLabel>
                                                    <NumberInput 
                                                        value={val.depth}
                                                        unit={"cm"}
                                                        onCommit={(e) => {
                                                            const v = parseFloat(e.target.value || 0.0);
                                                            // console.log("DEPTH", v);

                                                            onChangeDependencyValue({
                                                                payload: {
                                                                    type: "depth",
                                                                    characteristicId: item.characteristicId,
                                                                    target: val.valueName,
                                                                    value: v
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <FormLabel>Ancho</FormLabel>
                                                    <NumberInput 
                                                        value={val.width}
                                                        unit={"cm"}
                                                        onCommit={(e) => {
                                                            const v = parseFloat(e.target.value || 0.0);
                                                            // console.log("WIDTH", v);

                                                            onChangeDependencyValue({
                                                                payload: {
                                                                    type: "width",
                                                                    characteristicId: item.characteristicId,
                                                                    target: val.valueName,
                                                                    value: v
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                            
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: { xs: "column", md: "row" },
                                                    justifyContent: "space-evenly",
                                                    gap: 2
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <FormLabel>Alto</FormLabel>
                                                    <NumberInput
                                                        value={val.height} 
                                                        unit={"cm"}
                                                        onCommit={(e) => {
                                                            const v = parseFloat(e.target.value || 0.0);
                                                            // console.log("HEIGHT", v);

                                                            onChangeDependencyValue({
                                                                payload: {
                                                                    type: "height",
                                                                    characteristicId: item.characteristicId,
                                                                    target: val.valueName,
                                                                    value: v
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </Box>
                                                
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <FormLabel>Peso</FormLabel>
                                                    <NumberInput
                                                        value={val.weight_modifier}
                                                        unit={"kg"}
                                                        onCommit={(e) => {
                                                            const v = parseFloat(e.target.value || 0.0);
                                                            // console.log("WEIGHT", v);

                                                            onChangeDependencyValue({
                                                                payload: {
                                                                    type: "weight_modifier",
                                                                    characteristicId: item.characteristicId,
                                                                    target: val.valueName,
                                                                    value: v
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                            </>
                                    )}
                                    {
                                        (
                                            item.characteristicCategory === "price_only" 
                                            || item.characteristicCategory === "price_and_dimensions"
                                        ) && (
                                        <>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    width: "100%"
                                                }}
                                            >
                                                <FormLabel>Precio</FormLabel>
                                                <CurrencyInput
                                                    value={val.price_modifier}
                                                    unit={"USD"}
                                                    onCommit={(e) => {
                                                        const v = parseFloat(e.target.value || 0.0);
                                                        // console.log("PRICE", v);

                                                        onChangeDependencyValue({
                                                            payload: {
                                                                type: "price_modifier",
                                                                characteristicId: item.characteristicId,
                                                                target: val.valueName,
                                                                value: v
                                                            }
                                                        })
                                                    }}
                                                />
                                            </Box>
                                        </>
                                    )}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    )

}



function CharacteristicDependencyRuleModifiers({
    dependencyRules,
    setCurrSelectedRule,
    currSelectedRule,
    onChangeDependencyValue
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "100%",
                gap: 4
            }}
        >   
            <Box
                sx={{ 
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    p: 0,
                    gap: 4
                }}
            >
                <Box
                    sx={{ 
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        p: 0,
                        gap: 1
                    }}
                >
                    <FormLabel sx={formLabelStyle}>REGLA</FormLabel>
                    <Select
                        sx={{ width: "100%" }}
                        value={currSelectedRule || ""}
                        onChange={(e) => setCurrSelectedRule(e.target.value)}
                    >
                        <MenuItem value={""} disabled>Selecciona la Regla</MenuItem>
                        {dependencyRules && dependencyRules.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item.title}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
                
                <Box
                    sx={{ 
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        p: 0,
                        gap: 1
                    }}
                >
                    <FormLabel sx={{ ...formLabelStyle, color: "black", fontSize: "1.5rem" }}>{currSelectedRule.title}</FormLabel>
                    <FormLabel sx={formLabelStyle}>DIMENSIONES DE DEPENDENCIAS</FormLabel>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: "100%",
                            border: 1,
                            borderRadius: ".25rem",
                            borderColor: "#A1A1A1",
                            p: 2,
                        }}
                    >
                        <FormGroup
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", md: "row" },
                                    justifyContent: "space-between",
                                    width: "100%",
                                    alignItems: "center"
                                }}
                            >
                                <FormLabel sx={{color: "#FC581F"}}>Si</FormLabel>
                                <Box
                                    sx={{
                                        display: "flex",
                                        width: { xs: "100%", md: "45%" },
                                        flexWrap: { xs: "wrap", md: "nowrap" },
                                        alignItems: "center",
                                        gap: 2,
                                    }}
                                >
                                    <FormLabel>VALORES PRINCIPALES</FormLabel>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            width: "100%",
                                            height: "10rem",
                                            overflowY: "scroll",
                                            border: 1,
                                            borderColor: "#A1A1A1",
                                            borderRadius: ".25rem",
                                            p: 2
                                        }}
                                    >
                                        {currSelectedRule.primary?.map((item, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    p: 1,
                                                    borderBottom: 1,
                                                    borderColor: "#A1A1A1"
                                                }}
                                            >
                                                {item}
                                            </Box>
                                        ))
                                        }
                                    </Box>
                                </Box>
                                
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexWrap: { xs: "wrap", md: "nowrap" },
                                        width: { xs: "100%", md: "45%" },
                                        alignItems: "center",
                                        gap: 2,
                                    }}
                                >
                                    <FormLabel>CARACTERÍSTICAS Y VALORES</FormLabel>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            width: "100%",
                                            height: "10rem",
                                            overflowY: "scroll",
                                            border: 1,
                                            borderColor: "#A1A1A1",
                                            borderRadius: ".25rem",
                                            p: 2
                                        }}
                                    >
                                        {currSelectedRule && currSelectedRule.if.map((item, index) => (
                                            <>
                                                <DependencyRuleIf item={item} index={index} />
                                            </>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>

                            <FormLabel sx={{color: "#FC581F"}}>Entonces</FormLabel>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    maxHeight: "80rem",
                                    overflowY: "scroll",
                                    gap: 2,
                                    p: 2,
                                    border: 1,
                                    borderRadius: "0.25rem",
                                    borderColor: "#A1A1A1"
                                }}
                            >
                                {currSelectedRule.then?.map((item, index) => (
                                    <DependencyRuleThen 
                                        item={item} 
                                        index={index} 
                                        onChangeDependencyValue={onChangeDependencyValue} 
                                    />
                                ))}
                            </Box>
                        </FormGroup>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default CharacteristicDependencyRuleModifiers